

import React from 'react';
import { Text } from '../../../ui-kit';

import AssetPreview from '../../AssetPreview';





function SelectedAssets({ asset }) {
  if (!asset) {return null;}

  return (
    <div className="bulk-actions__selectedAsset-list__content">
      <AssetPreview
        height={80}
        width={80}
        asset={asset}
        hideFileTypeIcon
        rounded />

      <div className="bulk-actions__selectedAsset-list__content__asset-details">
        <Text heading5 noMargin ellipsisOverflow>{asset.title}</Text>
        {asset.description ? <Text noMargin="bottom" ellipsisOverflow label>{asset.description}</Text> : null}
      </div>
    </div>);

}

export default SelectedAssets;